import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const CopilotContext = createContext(null);

export function CopilotProvider({ children }) {
  const [activeEntity, setActiveEntity] = useState(null); // { id, type, name }
  const { pathname } = useLocation();
  useEffect(() => { setActiveEntity(null); }, [pathname]);
  return (
    <CopilotContext.Provider value={{ activeEntity, setActiveEntity }}>
      {children}
    </CopilotContext.Provider>
  );
}

export function useCopilot() {
  return useContext(CopilotContext) || { activeEntity: null, setActiveEntity: () => {} };
}
